import axios from "./axios";
import qs from "qs";
import { Message } from "element-ui";
import { normalizeLegacyJsonFields } from "./legacyJsonFields";
// let baseUrl = 'http://iaiyoxi.cn:8888/node/';
let baseUrl = "/node/";

function normalizeJsonFields(data, schema) {
  try {
    return normalizeLegacyJsonFields(data, schema);
  } catch (error) {
    Message.error(error.message || "请求参数格式错误");
    throw error;
  }
}

function postWithJsonFields(path, data, schema) {
  try {
    const payload = normalizeJsonFields(data, schema);
    return axios.post(baseUrl + path, qs.stringify(payload));
  } catch (error) {
    return Promise.reject(error);
  }
}

function getWithJsonFields(path, params, schema) {
  try {
    return axios.get(baseUrl + path, {
      params: normalizeJsonFields(params, schema),
    });
  } catch (error) {
    return Promise.reject(error);
  }
}
/**
 * requestType
 * group 广告组
 * activity 广告活动
 *
 */

export default {
  initShopType(data) {
    let shopType = localStorage.getItem("shopType");
    shopType != "" && (data.shopType = shopType);
  },
  fetchProducts(data) {
    this.initShopType(data);
    return axios.get(baseUrl + "fetchProducts", {
      params: data,
    });
  },
  fetchProductsByType(data) {
    return axios.get(baseUrl + "fetchProducts", {
      params: data,
    });
  },
  fetchBusinessData(data) {
    this.initShopType(data);
    return axios.get(baseUrl + "fetchBusinessData", {
      params: data,
    });
  },
  fetchProductAnalysisData(data) {
    return axios.get(baseUrl + "fetchProductAnalysisData", {
      params: data,
    });
  },
  fetchShops(data) {
    this.initShopType(data);
    return axios.get(baseUrl + "fetchShops", {
      params: data,
    });
  },
  importProduct(data) {
    return axios.post(baseUrl + "importProduct", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importOrder(data) {
    this.initShopType(data);
    return axios.post(baseUrl + "importOrder", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importReturnOrder(data) {
    this.initShopType(data);
    return axios.post(baseUrl + "importReturnOrder", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  fetchReturnOrders(data) {
    this.initShopType(data);
    return axios.get(baseUrl + "fetchReturnOrders", {
      params: data,
    });
  },
  fetchReturnOrderAnalysis(data) {
    return axios.get(baseUrl + "fetchReturnOrderAnalysis", {
      params: data,
    });
  },
  fetchReturnOrderAnalysisStatus(data) {
    return axios.get(baseUrl + "fetchReturnOrderAnalysisStatus", {
      params: data || {},
    });
  },
  generateReturnOrderAnalysis(data) {
    return axios.post(baseUrl + "generateReturnOrderAnalysis", qs.stringify(data));
  },
  fetchOrders(data) {
    this.initShopType(data);
    return axios.get(baseUrl + "fetchOrders", {
      params: data,
    });
  },
  analyzeOrders(data) {
    this.initShopType(data);
    return axios.get(baseUrl + "analyzeOrders", {
      params: data,
    });
  },
  importTrade(data) {
    return axios.post(baseUrl + "importTrade", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importVisit(data) {
    return axios.post(baseUrl + "importVisit", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importVisitManul(data) {
    return axios.post(baseUrl + "importVisitManul", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importProductAd(data) {
    return axios.post(baseUrl + "importProductAd", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importKeywordAd(data) {
    return axios.post(baseUrl + "importKeywordAd", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importAdvert(data) {
    return axios.post(baseUrl + "importAdvert", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importFBAInventory(data) {
    return axios.post(baseUrl + "importFBAInventory", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importTemuInventory(data) {
    return axios.post(baseUrl + "importTemuInventory", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importFbaFee(data) {
    return axios.post(baseUrl + "importFbaFee", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importFBAShipment(data) {
    return axios.post(baseUrl + "importFBAShipment", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importHotSearchKeyword(data) {
    return axios.post(baseUrl + "importHotSearchKeyword", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importKeywordSearchVolume(data) {
    return axios.post(baseUrl + "importKeywordSearchVolume", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  importKeywordRank(data) {
    return axios.post(baseUrl + "importKeywordRank", {
      params: data,
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8",
      },
    });
  },
  createSingleAdvert(data) {
    return axios.post(baseUrl + "createSingleAdvert", qs.stringify(data));
  },
  createAdvert(data) {
    return axios.post(baseUrl + "createAdvert", qs.stringify(data));
  },
  createBusinessData(parmas) {
    return axios.get(baseUrl + "createBusinessData", {});
  },
  fetchTemuInventorys(parmas) {
    return axios.get(baseUrl + "fetchTemuInventorys", {
      params: parmas,
    });
  },
  getInventoryAnalysisData(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "getInventoryAnalysisData", {
      params: parmas,
    });
  },
  fetchData(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchData", {
      params: parmas,
    });
  },
  fetchPurchaseData(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchPurchaseData", {
      params: parmas,
    });
  },
  fetchAdverts(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchAdverts", {
      params: parmas,
    });
  },
  fetchKeywordRanks(parmas) {
    this.initShopType(parmas);
    return getWithJsonFields("fetchKeywordRanks", parmas, {
      asinList: { type: "array", optional: true, omitEmptyArray: true },
    });
  },
  fetchProductAdvertsOld(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchProductAdvertsOld", {
      params: parmas,
    });
  },
  fetchProductAdverts(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchProductAdverts", {
      params: parmas,
    });
  },
  fetchParentProductAdverts(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchParentProductAdverts", {
      params: parmas,
    });
  },
  fetchProductAds(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchProductAds", {
      params: parmas,
    });
  },
  fetchDetailProductAds(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchDetailProductAds", {
      params: parmas,
    });
  },
  fetchKeywordAds(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchKeywordAds", {
      params: parmas,
    });
  },
  fetchDetailKeywordAds(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchDetailKeywordAds", {
      params: parmas,
    });
  },
  fetchProductData(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchProductData", {
      params: parmas,
    });
  },
  fetchProductWeight(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchProductWeight", {
      params: parmas,
    });
  },
  fetchKeywordWeight(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchKeywordWeight", {
      params: parmas,
    });
  },
  fetchKeywordWeights(parmas) {
    this.initShopType(parmas);
    return axios.get(baseUrl + "fetchKeywordWeights", {
      params: parmas,
    });
  },
  autoCreateKeywordAdByWeight(parmas) {
    return axios.get(baseUrl + "autoCreateKeywordAdByWeight", {
      params: parmas,
    });
  },
  addManualKeywordAdvert(data) {
    return postWithJsonFields("addManualKeywordAdvert", data, { keywords: "array" });
  },
  startKWAdvertTask(data) {
    return axios.post(baseUrl + "startKWAdvertTask", qs.stringify(data));
  },
  updateProductAdvert(data) {
    return axios.post(baseUrl + "updateProductAdvert", qs.stringify(data));
  },
  batchUpdateProductAdvert(data) {
    return postWithJsonFields("batchUpdateProductAdvert", data, { batchEditList: "array" });
  },
  autoCreateManaulKeywordAdvert(data) {
    return axios.post(baseUrl + "autoCreateManaulKeywordAdvert", qs.stringify(data));
  },
  updateKWWeight(data) {
    return axios.post(baseUrl + "updateKWWeight", qs.stringify(data));
  },
  updateParentProduct(data) {
    return axios.post(baseUrl + "updateParentProduct", qs.stringify(data));
  },
  fetchParentProducts(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchParentProducts", {
      params: params,
    });
  },
  fetchAllParentProducts(params) {
    return axios.get(baseUrl + "fetchParentProducts", {
      params: params,
    });
  },
  fetchPhoneCaseContantInfo(params) {
    return axios.get(baseUrl + "fetchPhoneCaseContantInfo", {
      params: params,
    });
  },
  addOrUpdateRuleNode(data) {
    return axios.post(baseUrl + "addOrUpdateRuleNode", qs.stringify(data));
  },
  fetchRuleNodes(params) {
    return axios.get(baseUrl + "fetchRuleNodes", {
      params: params,
    });
  },
  fetchRuleNode(params) {
    return axios.get(baseUrl + "fetchRuleNode", {
      params: params,
    });
  },
  deleteRuleNode(data) {
    return axios.post(baseUrl + "deleteRuleNode", qs.stringify(data));
  },

  addOrUpdateStrategy(data) {
    return axios.post(baseUrl + "addOrUpdateStrategy", qs.stringify(data));
  },
  fetchStrategys(params) {
    return axios.get(baseUrl + "fetchStrategys", {
      params: params,
    });
  },
  fetchStrategy(params) {
    return axios.get(baseUrl + "fetchStrategy", {
      params: params,
    });
  },
  deleteStrategy(data) {
    return axios.post(baseUrl + "deleteStrategy", qs.stringify(data));
  },
  fetchDecisions(params) {
    return axios.get(baseUrl + "fetchDecisions", {
      params: params,
    });
  },
  executeDecision(data) {
    return axios.post(baseUrl + "executeDecision", qs.stringify(data));
  },
  ignoreDecision(data) {
    return axios.post(baseUrl + "ignoreDecision", qs.stringify(data));
  },
  startKeywordWeightTask(data) {
    return axios.post(baseUrl + "startKeywordWeightTask", qs.stringify(data));
  },
  fetchProductChartData(params) {
    return axios.get(baseUrl + "fetchProductChartData", {
      params: params,
    });
  },
  updateProductRank(data) {
    return axios.post(baseUrl + "updateProductRank", qs.stringify(data));
  },
  batchUpdateProductPrice(data) {
    return postWithJsonFields("batchUpdateProductPrice", data, { productList: "array" });
  },
  setParentProductAsin(data) {
    return axios.post(baseUrl + "setParentProductAsin", qs.stringify(data));
  },
  configProductMaterial(data) {
    return postWithJsonFields("configProductMaterial", data, { materialConfig: "array" });
  },
  configCompetitorAsins(data) {
    return postWithJsonFields("configCompetitorAsins", data, { competitorAsins: "array" });
  },
  addColor(data) {
    return axios.post(baseUrl + "addColor", qs.stringify(data));
  },
  resetProductStatus(data) {
    return axios.post(baseUrl + "resetProductStatus", qs.stringify(data));
  },
  fetchKeywordStatistic(params) {
    // this.initShopType(params);
    return axios.get(baseUrl + "fetchKeywordStatistic", {
      params: params,
    });
  },
  fetchKeywordStatistics(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchKeywordStatistics", {
      params: params,
    });
  },
  fetchKeywordStatisticChatData(params) {
    return axios.get(baseUrl + "fetchKeywordStatisticChatData", {
      params: params,
    });
  },
  fetchKeywordAdverts(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchKeywordAdverts", {
      params: params,
    });
  },
  runKeywordStatistics(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "runKeywordStatistics", {
      params: params,
    });
  },

  getProductKeywordAnalyze(params) {
    return axios.get(baseUrl + "getProductKeywordAnalyze", {
      params: params,
    });
  },
  updateProductKeywordInfo(data) {
    return postWithJsonFields("updateProductKeywordInfo", data, { campetitorInfo: "object" });
  },

  updateDeliveryWordConfig(data) {
    return axios.post(baseUrl + "updateDeliveryWordConfig", qs.stringify(data));
  },

  fetchProductKeyword(params) {
    return axios.get(baseUrl + "fetchProductKeyword", {
      params: params,
    });
  },
  updateProductKeyword(data) {
    return axios.post(baseUrl + "updateProductKeyword", qs.stringify(data));
  },
  autoAddManualKeywordsAdvert(data) {
    return axios.post(baseUrl + "autoAddManualKeywordsAdvert", qs.stringify(data));
  },
  autoAdjustManualKeywordsAdvert(data) {
    return axios.post(baseUrl + "autoAdjustManualKeywordsAdvert", qs.stringify(data));
  },
  runProductKeywordAnalyzeStatistics(data) {
    return axios.post(baseUrl + "runProductKeywordAnalyzeStatistics", qs.stringify(data));
  },

  createPurchasePlan(data) {
    return postWithJsonFields("createPurchasePlan", data, { shopTypes: "array" });
  },
  fetchPurchasePlans(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchPurchasePlans", {
      params: params,
    });
  },
  fetchPurchasePlansForOutStock(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchPurchasePlansForOutStock", {
      params: params,
    });
  },
  addOrUpdatePurchasePlan(data) {
    return axios.post(baseUrl + "addOrUpdatePurchasePlan", qs.stringify(data));
  },
  fetchPurchases(params) {
    this.initShopType(params);
    return getWithJsonFields("fetchPurchases", params, {
      shopTypeList: { type: "array", optional: true },
      productTypeList: { type: "array", optional: true },
      supplierIdList: { type: "array", optional: true },
    });
  },
  addOrUpdatePurchase(data) {
    return axios.post(baseUrl + "addOrUpdatePurchase", qs.stringify(data));
  },
  deletePurchase(data) {
    return axios.post(baseUrl + "deletePurchase", qs.stringify(data));
  },
  deletePurchases(data) {
    return axios.post(baseUrl + "deletePurchases", qs.stringify(data));
  },
  importPurchase(data) {
    return axios.post(baseUrl + "importPurchase", qs.stringify(data));
  },

  addOrUpdateOutStockPlan(data) {
    return postWithJsonFields("addOrUpdateOutStockPlan", data, {
      lyBoxWeights: { type: "array", optional: true },
      payBoxWeights: { type: "array", optional: true },
    });
  },
  confirmOutStockPlan(data) {
    return postWithJsonFields("confirmOutStockPlan", data, {
      chooseOutStockPlan: "object",
      finalRedundantAsinStockList: { type: "array", optional: true },
      finalReduceAsinStockList: { type: "array", optional: true },
    });
  },

  fetchOutStockPlans(params) {
    this.initShopType(params);
    return getWithJsonFields("fetchOutStockPlans", params, {
      statusList: { type: "array", optional: true },
    });
  },
  fetchOutStockPlanSkuSearch(params) {
    this.initShopType(params);
    return getWithJsonFields("fetchOutStockPlanSkuSearch", params, {
      statusList: { type: "array", optional: true, omitEmptyArray: true },
    });
  },
  fetchOutPlanList(params) {
    return axios.get(baseUrl + "fetchOutPlanList", {
      params: params,
    });
  },
  fetchOutStockPlan(params) {
    return axios.get(baseUrl + "fetchOutStockPlan", {
      params: params,
    });
  },
  fetchExportPurchases(params) {
    return getWithJsonFields("fetchExportPurchases", params, { selectedList: "array" });
  },
  fetchExportPurchaseMaterials(params) {
    return getWithJsonFields("fetchExportPurchaseMaterials", params, { selectedList: "array" });
  },
  createOutStockPlan(data) {
    return axios.post(baseUrl + "createOutStockPlan", qs.stringify(data));
  },
  outStockPlanAddBox(data) {
    return axios.post(baseUrl + "outStockPlanAddBox", qs.stringify(data));
  },
  fiveBoxOutStockPlanAddSKU(data) {
    return axios.post(baseUrl + "fiveBoxOutStockPlanAddSKU", qs.stringify(data));
  },
  fiveBoxOutStockPlanDeleteSKU(data) {
    return axios.post(baseUrl + "fiveBoxOutStockPlanDeleteSKU", qs.stringify(data));
  },
  outAsinStockEditFictitiousQuantity(data) {
    return axios.post(baseUrl + "outAsinStockEditFictitiousQuantity", qs.stringify(data));
  },
  outStockPlanEditBoxWeight(data) {
    return axios.post(baseUrl + "outStockPlanEditBoxWeight", qs.stringify(data));
  },
  outStockPlanDeleteBox(data) {
    return axios.post(baseUrl + "outStockPlanDeleteBox", qs.stringify(data));
  },
  outAsinStockSplit(data) {
    return axios.post(baseUrl + "outAsinStockSplit", qs.stringify(data));
  },
  outAsinStockMerge(data) {
    return axios.post(baseUrl + "outAsinStockMerge", qs.stringify(data));
  },
  outAsinStockBoxConfig(data) {
    return postWithJsonFields("outAsinStockBoxConfig", data, { asinStockIdList: "array" });
  },
  updatePurchases(data) {
    return postWithJsonFields("updatePurchases", data, {
      productTypes: "array",
      productTypesAndColors: "array",
      productTypesAndModels: "array",
      models: "array",
      skus: "array",
    });
  },
  updatePurchasesSupplier(data) {
    return axios.post(baseUrl + "updatePurchasesSupplier", qs.stringify(data));
  },
  updateInvoiceState(data) {
    return axios.post(baseUrl + "updateInvoiceState", qs.stringify(data));
  },
  statisticLocalInventorys(data) {
    return axios.post(baseUrl + "statisticLocalInventorys", qs.stringify(data));
  },
  fetchLocalInventorys(params) {
    return axios.get(baseUrl + "fetchLocalInventorys", {
      params: params,
    });
  },
  fetchInventoryChecks(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchInventoryChecks", {
      params: params,
    });
  },
  createInventoryCheck(data) {
    return postWithJsonFields("createInventoryCheck", data, { scopes: "array" });
  },
  updateInventoryCheckRemark(data) {
    return axios.post(baseUrl + "updateInventoryCheckRemark", qs.stringify(data));
  },
  voidInventoryCheck(data) {
    return axios.post(baseUrl + "voidInventoryCheck", qs.stringify(data));
  },
  startInventoryCheck(data) {
    return axios.post(baseUrl + "startInventoryCheck", qs.stringify(data));
  },
  fetchInventoryCheckDetails(params) {
    return axios.get(baseUrl + "fetchInventoryCheckDetails", {
      params: params,
    });
  },
  fetchInventoryCheckAdjust(params) {
    return axios.get(baseUrl + "fetchInventoryCheckAdjust", {
      params: params,
    });
  },
  fetchInventoryAdjust(params) {
    return axios.get(baseUrl + "fetchInventoryAdjust", {
      params: params,
    });
  },
  submitInventoryCheck(data) {
    return postWithJsonFields("submitInventoryCheck", data, { lines: "array" });
  },
  rejectInventoryCheckDiff(data) {
    return axios.post(baseUrl + "rejectInventoryCheckDiff", qs.stringify(data));
  },
  confirmInventoryCheckDiff(data) {
    return postWithJsonFields("confirmInventoryCheckDiff", data, { lines: "array" });
  },
  createManualInventoryAdjust(data) {
    return postWithJsonFields("createManualInventoryAdjust", data, { lines: "array" });
  },
  voidInventoryAdjust(data) {
    return axios.post(baseUrl + "voidInventoryAdjust", qs.stringify(data));
  },
  fetchOutStockLocalInventorys(params) {
    return axios.get(baseUrl + "fetchOutStockLocalInventorys", {
      params: params,
    });
  },
  outAsinStockAddSKU(data) {
    return axios.post(baseUrl + "outAsinStockAddSKU", qs.stringify(data));
  },
  outAsinStockAddRedundantSKUs(data) {
    return postWithJsonFields("outAsinStockAddRedundantSKUs", data, { redundantList: "array" });
  },
  outAsinStockDeleteSKU(data) {
    return axios.post(baseUrl + "outAsinStockDeleteSKU", qs.stringify(data));
  },
  createInventoryData(data) {
    return postWithJsonFields("createInventoryData", data, { shopTypes: "array" });
  },
  addToPurchases(data) {
    return postWithJsonFields("addToPurchases", data, { selectedList: "array" });
  },
  fetchPurchaseRecords(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchPurchaseRecords", {
      params: params,
    });
  },
  voidPurchaseRecords(data) {
    return axios.post(baseUrl + "voidPurchaseRecords", qs.stringify(data));
  },
  confirmPurchaseRecords(data) {
    return axios.post(baseUrl + "confirmPurchaseRecords", qs.stringify(data));
  },
  rejectPurchaseRecords(data) {
    return axios.post(baseUrl + "rejectPurchaseRecords", qs.stringify(data));
  },
  updatePurchaseRecordQuantity(data) {
    return axios.post(baseUrl + "updatePurchaseRecordQuantity", qs.stringify(data));
  },
  addToPurchaseRecords(data) {
    return axios.post(baseUrl + "addToPurchaseRecords", qs.stringify(data));
  },
  addManualPurchaseRecord(data) {
    return postWithJsonFields("addManualPurchaseRecord", data, { lines: "array" });
  },
  fetchExportPurchaseRecords(data) {
    return axios.post(baseUrl + "fetchExportPurchaseRecords", qs.stringify(data));
  },
  fetchExportPurchaseRecordMaterials(data) {
    return axios.post(baseUrl + "fetchExportPurchaseRecordMaterials", qs.stringify(data));
  },
  fetchPurchaseOrders(params) {
    this.initShopType(params);
    return axios.get(baseUrl + "fetchPurchaseOrders", {
      params: params,
    });
  },
  fetchPurchaseOrderPurchaseRecords(params) {
    return axios.get(baseUrl + "fetchPurchaseOrderPurchaseRecords", {
      params: params,
    });
  },
  fetchPurchaseOrderPurchaseMaterials(params) {
    return axios.get(baseUrl + "fetchPurchaseOrderPurchaseMaterials", {
      params: params,
    });
  },
  transitionPurchaseOrderStatus(data) {
    return axios.post(baseUrl + "transitionPurchaseOrderStatus", qs.stringify(data));
  },
  fetchPurchaseOrderReceiptSkus(data) {
    return axios.post(baseUrl + "fetchPurchaseOrderReceiptSkus", qs.stringify(data));
  },
  fetchPurchaseOrderReceiptDefectSkus(data) {
    return axios.post(baseUrl + "fetchPurchaseOrderReceiptDefectSkus", qs.stringify(data));
  },
  fetchPurchaseOrderSelectedSkus(data) {
    return axios.post(baseUrl + "fetchPurchaseOrderSelectedSkus", qs.stringify(data));
  },
  confirmPurchaseOrderReceipt(data) {
    return axios.post(baseUrl + "confirmPurchaseOrderReceipt", qs.stringify(data));
  },
  fetchPurchaseOrderExchangeSkus(data) {
    return axios.post(baseUrl + "fetchPurchaseOrderExchangeSkus", qs.stringify(data));
  },
  createPurchaseOrderExchange(data) {
    return axios.post(baseUrl + "createPurchaseOrderExchange", qs.stringify(data));
  },
  fetchPurchaseOrderReceipts(data) {
    return axios.post(baseUrl + "fetchPurchaseOrderReceipts", qs.stringify(data));
  },
  fetchPurchaseOrderReceiptHistory(params) {
    return axios.get(baseUrl + "fetchPurchaseOrderReceiptHistory", {
      params: params,
    });
  },
  fetchPurchaseOrderReceiptDetail(params) {
    return axios.get(baseUrl + "fetchPurchaseOrderReceiptDetail", {
      params: params,
    });
  },
  updatePurchaseOrderReceiptLines(data) {
    return axios.post(baseUrl + "updatePurchaseOrderReceiptLines", qs.stringify(data));
  },
  voidPurchaseOrderReceipt(data) {
    return axios.post(baseUrl + "voidPurchaseOrderReceipt", qs.stringify(data));
  },
  createPurchaseOrders(data) {
    return axios.post(baseUrl + "createPurchaseOrders", qs.stringify(data));
  },
  previewCreatePurchaseOrders(data) {
    return axios.post(baseUrl + "previewCreatePurchaseOrders", qs.stringify(data));
  },
  fetchPurchaseOrderForEdit(params) {
    return axios.get(baseUrl + "fetchPurchaseOrderForEdit", {
      params: params,
    });
  },
  updatePurchaseOrderPayment(data) {
    return axios.post(baseUrl + "updatePurchaseOrderPayment", qs.stringify(data));
  },
  updatePurchaseOrderAttachment(data) {
    return axios.post(baseUrl + "updatePurchaseOrderAttachment", qs.stringify(data));
  },
  batchUpdateStockCycle(data) {
    return postWithJsonFields("batchUpdateStockCycle", data, { productList: "array" });
  },
  updatePlanPurchaseAdjust(data) {
    return axios.post(baseUrl + "updatePlanPurchaseAdjust", qs.stringify(data));
  },
  outAsinStockPlanConfig(data) {
    return postWithJsonFields("outAsinStockPlanConfig", data, { asinStockIdList: "array" });
  },
  updateDayOrderAdjust(data) {
    return axios.post(baseUrl + "updateDayOrderAdjust", qs.stringify(data));
  },

  fetchSuppliers(params) {
    return axios.get(baseUrl + "fetchSuppliers", {
      params: params,
    });
  },
  addOrUpdateSupplier(data) {
    return postWithJsonFields("addOrUpdateSupplier", data, {
      productCheckList: { type: "array", optional: true },
    });
  },
  updateSupplierInvoiceInfo(data) {
    return axios.post(baseUrl + "updateSupplierInvoiceInfo", qs.stringify(data));
  },

  fetchMaterials(params) {
    return axios.get(baseUrl + "fetchMaterials", {
      params: params,
    });
  },
  addOrUpdateMaterial(data) {
    return postWithJsonFields("addOrUpdateMaterial", data, {
      colorList: { type: "array", optional: true },
      purcharseColorList: { type: "array", optional: true },
    });
  },
  batchUpdateKWModel(data) {
    return axios.post(baseUrl + "batchUpdateKWModel", qs.stringify(data));
  },
  fetchTemuOpportunityProducts(params) {
    return axios.get(baseUrl + "fetchTemuOpportunityProducts", {
      params: params,
    });
  },
  updateTemuOpportunityProducts(data) {
    return postWithJsonFields("updateTemuOpportunityProducts", data, { products: "array" });
  },
  opportunityProductMarkStar(data) {
    return axios.post(baseUrl + "opportunityProductMarkStar", qs.stringify(data));
  },
  editOpportunityProduct(data) {
    return axios.post(baseUrl + "editOpportunityProduct", qs.stringify(data));
  },

  fetchOutStockBoxs(params) {
    return axios.get(baseUrl + "fetchOutStockBoxs", {
      params: params,
    });
  },
  addOrUpdateOutStockBox(data) {
    return axios.post(baseUrl + "addOrUpdateOutStockBox", qs.stringify(data));
  },
  fetchOpreateLogs(params) {
    return axios.get(baseUrl + "fetchOpreateLogs", {
      params: params,
    });
  },
  deleteInventoryAdjustOpreateLog(data) {
    return axios.post(baseUrl + "deleteInventoryAdjustOpreateLog", qs.stringify(data));
  },
  fetchExportFBAFees(params) {
    return axios.get(baseUrl + "fetchExportFBAFees", {
      params: params,
    });
  },
  addManualProductAdvert(data) {
    return axios.post(baseUrl + "addManualProductAdvert", qs.stringify(data));
  },

  fetchSamples(params) {
    return axios.get(baseUrl + "fetchSamples", {
      params: params,
    });
  },
  getSampleStatics(params) {
    return axios.get(baseUrl + "getSampleStatics", {
      params: params,
    });
  },
  addOrUpdateSample(data) {
    return axios.post(baseUrl + "addOrUpdateSample", qs.stringify(data));
  },
};
